import { request } from '@/utils/request'
import API from '@/constants/apis'
import * as types from './mutation-types'

export const getMyInfo = ({
  commit
}) => {
  return request(API.MY_INFO_API, 'GET', {}).then(res => {
    if (res && res.success) {
      commit(types.SET_MY_INFO, res)
    }
    return res
  })
}
export const refundCheck = ({
  commit
}) => {
  return request(API.REFUND_CHECK, 'GET', {}).then(res => {
    if (res && res.success) {
      commit(types.REFUND_CHECK, res)
    }
    return res
  })
}
// 检查是否可进行兑换码登录
export const voucherCheck = ({
  commit
}) => {
  return request(API.REFUND_CHECK, 'GET', {}).then(res => {
    if (res && res.success) {
      commit(types.REFUND_CHECK, res)
    }
    return res
  })
}
export const deleteOrder = ({
  commit, state
}, {
  orderId
}) => {
  return request(API.DELETE_ORDER_API, 'POST', {
    orderId
  }).then(res => {
    if (res && res.success) {
      const deleteOrder = state.myInfo.orders.filter(order => {
        return order.orderId !== orderId
      })
      commit(types.DELETE_ORDER, deleteOrder)
    }
    return res
  })
}
export const getCouponDetail = async ({
  commit
}, { couponId }) => {
  const res = await request(API.COUPON_DETAIL_API, 'GET', {})
  if (res && res.success) {
    commit(types.SET_CURRENT_COUPON, res)
  }
  return res
}

export const getFAQ = ({
  commit
}) => {
  return request(API.FAQ, 'GET', {}).then(res => {
    if (res && res.success) {
      commit(types.SET_FAQ, res.faqData)
      commit(types.SET_USERNAME, res.userName)
    }
    return res
  })
}



// WEBPACK FOOTER //
// ./src/store/my/actions.js